import React, { FC, useEffect, useState } from 'react';
import { getDashboardData, IDashboardData } from '../../services/dashboard';
import { CreateSurveyTypeNames } from '../../constans/state';
import Spinner from '../../components/Spinner/Spinner';
import { SpinnerCont } from './Overview/Overview.styles';
import Overview from './Overview/Overview';
import Departments from './Departments/Departments';

interface IDashboard {
  surveyId: string;
  domain: string;
  isEffect: boolean;
  surveyType: string;
}

const Dashboard: FC<IDashboard> = ({ surveyId, domain, isEffect, surveyType }) => {
  const [data, setData] = useState<IDashboardData | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await getDashboardData(surveyId);
        setData(result);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [surveyId]);

  if (loading || !data) {
    return <SpinnerCont><Spinner size="large" /></SpinnerCont>;
  }

  if (domain === CreateSurveyTypeNames.departments) {
    return <Departments tableRows={data.tableRows} isEffect={isEffect} surveyType={surveyType} />;
  }

  return <Overview data={data} />;
};

export default Dashboard;
